import { render } from "./CreateHomepageSection.vue?vue&type=template&id=2945733b&scoped=true"
import script from "./CreateHomepageSection.vue?vue&type=script&lang=js"
export * from "./CreateHomepageSection.vue?vue&type=script&lang=js"

import "./CreateHomepageSection.vue?vue&type=style&index=0&id=2945733b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2945733b"]])

export default __exports__